"use client";

import React from "react";
import { Quote, MapPin, Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  type: "Owner",
  name: "Sarah Jenkins",
  role: "Property Owner",
  neighborhood: "Red Bud Area",
  quote: "Taillet has significantly increased our rental income and provided exceptional tenant care. I finally have peace of mind knowing my investment is in good hands.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/avatar_sarah_jenkins.png"
}, {
  id: 2,
  type: "Tenant",
  name: "Michael Rivera",
  role: "Happy Renter",
  neighborhood: "Downtown Abilene",
  quote: "The maintenance team is quick and professional, making my living experience stress-free. It's rare to find a management company that truly cares about tenants.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/avatar_michael_rivera.png"
}, {
  id: 3,
  type: "Owner",
  name: "James Caldwell",
  role: "Commercial Investor",
  neighborhood: "Industrial District",
  quote: "Their financial reporting is impeccable. I can track my portfolio's performance in real-time, and their leasing strategy has kept my vacancy rates near zero.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/avatar_james_caldwell.png"
}, {
  id: 4,
  type: "Tenant",
  name: "Emily Chen",
  role: "Long-Term Resident",
  neighborhood: "Elm Creek",
  quote: "I've been renting with Taillet for three years now. The process was seamless from day one, and they are always responsive to any questions I have.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/avatar_emily_chen.png"
}, {
  id: 5,
  type: "Owner",
  name: "Robert & Linda H.",
  role: "Multi-Family Owners",
  neighborhood: "Sayles Blvd",
  quote: "We switched to Taillet last year and the difference is night and day. They handle everything from tenant placement to late-night maintenance calls professionally.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/avatar_robert_linda.png"
}, {
  id: 6,
  type: "Tenant",
  name: "David Okonjo",
  role: "Short-Term Lessee",
  neighborhood: "Lytle South",
  quote: "Found the perfect furnished apartment for my 6-month contract. Clean, modern, and exactly as described. The move-in process was incredibly smooth.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/avatar_david_okonjo.png"
}];
export default function ClientSuccessStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}